import { useCallback, useMemo } from 'react'
import type { IMoreMenuItem } from '@sales-center/components'
import type { CustomFieldListItemProps } from './CustomFieldListItem'

export function useActions(props: CustomFieldListItemProps) {
  const { customField, customFieldOptions = [], openForm, openDelete } = props

  const onEditClick = useCallback(
    () =>
      openForm({
        id: `${customField.id}`,
        title: customField.name,
        fieldType: customField.type,
        options: customFieldOptions.map((opt) => ({
          id: `${opt.id}`,
          name: opt.name,
          active: opt.active,
        })),
      }),
    [customField, customFieldOptions, openForm],
  )

  const onDeleteClick = useCallback(
    () => openDelete(customField.id),
    [customField.id, openDelete],
  )

  return useMemo<IMoreMenuItem[]>(
    () => [
      { label: 'Edit', onClick: onEditClick },
      { label: 'Delete', onClick: onDeleteClick },
    ],
    [onEditClick, onDeleteClick],
  )
}
